import Tabs from './tabs';
export type { AbstractTabItemProps as TabItemProps } from './tabs.types';

export default Tabs;
